var exports = {
  "A": "x234b8571--17760d--item",
  "D": "x234b8571--17760d--title",
};

module.exports = exports;
